// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Modal-ModalHeader-module--cls1--wQuGO","cls2":"Modal-ModalHeader-module--cls2--1HiVj Modal-ModalHeader-module--cls1--wQuGO"};